import * as navbarimage from '../../images/logo.svg'; //Top-level of the document
// import * as navbarimageslogan from '../../images/ICMC_70.svg'; //Top-level of the document

export default {
  init() {
    // JavaScript to be fired on all pages
    /**
     * Button "Show More"
     */
    $(document).on('click', '.js-accordion-trigger', function() {
      const target = $(this).data('target');
      $('.'+target).toggleClass('hidden');
      $(this).find('span').toggleClass('is-open');
    });
    // Carousel
    $('.js-carousel').slick({
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 6000,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow:
        '<button type="button" class="c-Slider-prev"><span class="o-Icon"></span></button>',
      nextArrow:
        '<button type="button" class="c-Slider-next"><span class="o-Icon"></span></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

    $('.js-BigSlider').slick({
      useTransform: true,
      autoplay: true,
      adaptiveHeight: false,
      autoplaySpeed: 10000,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      dots: true,
      pauseOnDotsHover: true,
      fade: true,
      cssEase: 'ease-out',
      draggable: false,
      prevArrow:
        '<button type="button" class="c-Slider-prev"><span class="o-Icon"></span></button>',
      nextArrow:
        '<button type="button" class="c-Slider-next"><span class="o-Icon"></span></button>',
      responsive: [
        {
          breakpoint: 480,
          settings: {
            arrows: false,
          },
        },
      ],
    });

    // function resizeSlider(){

    //   var customheight = $(window).height() - $('.c-section-slider').next().height() - $('.site-header').height() - 30;
    //  if( customheight >= 500 ){

    //  }
    //   $('.c-hero__slider .c-slider-item').css('height', customheight);
    // }
    // resizeSlider();
    // $(window).resize(function () {
    //  resizeSlider();
    // });





     /**
     * IMAGES BACKGROUND RESPONSIVE
     */
      class ResponsiveBackgroundImage {

        constructor(element) {
            this.element = element;
            this.img = element.querySelector('img');
            this.src = '';

            if (this.img) {
            this.img.addEventListener('load', () => {
                this.update();
            });
          }
          if (this.img) {
            if (this.img.complete) {
                this.update();
            }
          }
        }

        update() {
            let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
            if (this.src !== src) {
                this.src = src;
                this.element.style.backgroundImage = 'url("' + this.src + '")';
            }
        }
    }

    let elements = document.querySelectorAll('[data-responsive-background-image]');

    for (let i=0; i<elements.length; i++) {
      new ResponsiveBackgroundImage(elements[i]);
    }

   /**
    * SVG REPLACE
    * Replace all SVG images with inline SVG
    */

    $('img.svg').each(function(){
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      $.get(imgURL, function(data) {
          // Get the SVG tag, ignore the rest
          var $svg = $(data).find('svg');

          // Add replaced image's ID to the new SVG
          if(typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
          }
          // Add replaced image's classes to the new SVG
          if(typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass+' replaced-svg');
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr('xmlns:a');

          // Replace image with new SVG
          $img.replaceWith($svg);

      }, 'xml');

    });


    /**
     *  MENU (mmenu.js)
     */

    var $navMobilePrimary = $('.js-mobile-menu');

    $navMobilePrimary.mmenu(
      {
        wrappers: ['wordpress'],
        className: {
          //selected: "active",
        },
        navbar: {
          // add: false,
        },
        onClick: {
          close: false,
        },
        //sub-menu slide or drop-down ?
        slidingSubmenus: true,
        extensions: [
          // "position-back",
          'position-right',
        ],
        navbars		: [{
          height 	: 2,
          content : [
            '<div class="flex"><img class="mb-4 w-1/2" src="' + navbarimage + '" /></div>',
            '<a href="./donate" class="menu-donate btn btn--yellow uppercase text-white">Donate today</a>',
          ],
        }],
      },
      {
        // configuration
        clone: true,
      }
    );

    var $navTrigger = $('#js-mobile-menu-trigger'),
      myMenu = $('.mm-menu').data('mmenu');

    $navTrigger.on('click', function(e) {
      e.preventDefault();
      var $this = $(this);
      if ($this.hasClass('is-active')) {
        myMenu.close();
      } else {
        myMenu.open();
      }
    });

    myMenu.bind('open:finish', function() {
      setTimeout(function() {
        $navTrigger.addClass('is-active');
      }, 50);
    });
    myMenu.bind('close:finish', function() {
      setTimeout(function() {
        $navTrigger.removeClass('is-active');
      }, 50);
    });

    /**
     *  MENU SCROLL (mhead.js)
     */

    $('.site-header--mobile').mhead({
      scroll: {
        hide: 200,
      },
    });


    // Lightcase pour les galeries

    $('.wp-block-gallery a').lightcase({
      maxWidth: 1920,
      maxHeight: 1280,
      slideshow: true,
      slideshowAutoStart: false,
      // showTitle: true,
    });

    $('.gallery-item a').lightcase({
      maxWidth: 1920,
      maxHeight: 1280,
      slideshow: true,
      slideshowAutoStart: false,
      // showTitle: true,
    });

    /**
     *
     *  MODALE (pour les formulaires de contact)
     */

    // Apparition de la modale

    function toggleMyModal (el) {
      el.toggleClass('opacity-0')
      el.toggleClass('pointer-events-none')
      $('body').toggleClass('modal-active')
    }

    // Ouverture de la modale

    $(document).on('click', '.modal-opener', function() {
      // si on est dans une card on doit changer le titre de la modale
      var card_title = $(this).closest('.c-card').find('.js-title-src').html();
      if( card_title ){
        $('.js-title-dest').html(card_title);
      }
      var modal = $('.my-modal-open');
      var contact_id = $(this).parents('article').data('id');
      // Le champ [16] est un champ caché.
      // Attention il est lié à une fonction add_filter('frm_to_email') qui est dans /app/filters.php
      $('input[name="item_meta[16]"]').val(contact_id);
      toggleMyModal(modal);
    });

    // Modale VIDEO
    var modalVideo = $('.js-video-modal');
    var srcVideo = modalVideo.find('iframe').attr('src');


    $(document).on('click', '.js-video', function() {
      modalVideo.find('iframe').attr('src', '');
      modalVideo.find('iframe').attr('src', srcVideo +'&autoplay=1');
      toggleMyModal(modalVideo);
    });

    $('.js-video-close').click(function(){
      var modalVideo = $(this).closest('.my-modal-open');
      toggleMyModal(modalVideo);
      $('#video-content iframe').attr('src', '');
    });

    // Fermeture de la modale

    $('.modal-close').click(function(){
      var modal = $(this).closest('.my-modal-open');
      toggleMyModal(modal);
    });

    // AND  Modal close if click outside

    $(document).on('click', 'body.modal-active', function(event) {
      if( !$(event.target).closest('.my-modal-content').length && !$(event.target).is('.my-modal-content')) {
        var modal = $('.my-modal-open');
        toggleMyModal(modal[0]);
        $('#video-content iframe').attr('src', '');
      }
    });

    /**
     * SEARCH
     */

    // Termes recherchés visibles uniquement

    var tt = $('.facetwp-selections');

    if(tt.length > 0) {
      $('body').on('DOMSubtreeModified', tt, function() {
        if (tt.html().length === 0) {
          $('.searched').addClass('hidden');
        } else {
          $('.searched').removeClass('hidden');
        }
      });
    }



    // redirect on "enter" key press
    $('body').on('keyup', '.facetwp-search', function (e) {
      if (e.keyCode == '13') {
        // eslint-disable-next-line
        fwp_redirect();
      }
    });

    // Evénements suivants et passé

    const period = $('.js-calendar-select');
    period.change(function () {
      if ($(this).val() == 'past') {
        $('.past-events').show();
        $('.next-events').hide();
      } else {
        $('.past-events').hide();
        $('.next-events').show();
      } // hide div if value is not "custom"
    });


    /**
     * INPUT PLACEHOLDER FORMULAIRE
     */

    $('.frm_form_field input').blur(function() {
      $(this).removeClass('focus');
      $(this).prev().removeClass('is-visible');
    })
    .focus(function() {
      $(this).addClass('focus');
      $(this).prev().addClass('is-visible');
    });

    $('.frm_form_field textarea').blur(function() {
      $(this).removeClass('focus');
      $(this).prev().removeClass('is-visible');
    })
    .focus(function() {
      $(this).addClass('focus');
      $(this).prev().addClass('is-visible');
    });


    // GEOIP MODAL

    function openEuModal() {
      var modal = document.querySelector('.js-modal-geoip')
      var body = document.querySelector('body')
      modal.classList.toggle('opacity-0');
      modal.classList.toggle('pointer-events-none');
      body.classList.toggle('modal-active');
    }

    if ( $('.js-modal-geoip').length > 0 ) {
      if (localStorage.getItem('geoip-detect-result') !== null) {
        // console.log('geoip');
      } else {
        geoip_detect.get_info().then(function (record) { // eslint-disable-line
          if (record.error()) {
            console.error('WARNING Geodata Error:' + record.error());
          }
          var continent = record.get('continent.code');
          // console.log('continent "' + continent + '" detected');.
          if (continent == 'EU') {
            setTimeout(openEuModal, 5000);
          }
        });
          // if(mygeoip){
          //   var modal = $('.js-modal-geoip');
          //   toggleMyModal(modal);
          // }
        $('.js-modal-geoip .modal-close').on('click', function () {
          var modal = $(this).closest('.js-modal-geoip');
          toggleMyModal(modal);
        });
      }
    }
    // .log(geoip_detect2_get_info_from_current_ip())



  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js